import Vue from 'vue';
import InfiniteLoading from 'vue-infinite-loading';
Vue.use(InfiniteLoading, { /* 配置 */ });